import { JSX } from 'react';
import { useRecordContext } from 'react-admin';
import { Alert, Box } from '@mui/material';
import { CompanyDomainsPanel } from './CompanyDomainsPanel';
import { CustomerAccountAllowanceBar } from '../CustomerAccount/CustomerAccountAllowanceBar';
import { useAccountAllowances } from '../CustomerAccount/hooks/customer-account-allowances';

/**
 * The company screen's Domains tab: the account's domain pool, then its domains.
 *
 * The allowance is read here rather than passed in, because this screen is reached from the
 * sidebar as often as from an account and there is no account context around it. On the account's
 * own Company and Domain tab the same panel is handed the tab's existing read instead, so the
 * band at the top of that tab and the panel underneath cannot disagree.
 */
export const CompanyDomainsTab: () => JSX.Element = (): JSX.Element => {
    const company: any = useRecordContext();
    const customerAccountId: string|undefined = company?.customerAccount;
    const { allowances, loadingAllowances, allowancesError, reloadAllowances } =
        useAccountAllowances(customerAccountId);

    return (
        <Box sx={ { width: '100%' } }>
            { (customerAccountId !== undefined && customerAccountId !== null && customerAccountId !== '') &&
                <CustomerAccountAllowanceBar allowances={ allowances }
                                             loading={ loadingAllowances }
                                             error={ allowancesError }
                                             pools={ ['domains'] } />
            }
            { (customerAccountId === undefined || customerAccountId === null || customerAccountId === '') &&
                <Alert severity="info" sx={ { marginBottom: '10px' } }>
                    { 'This company is a CRM record with no customer account, so it has no subscription and no domain allowance. Its existing domains are listed below.' }
                </Alert>
            }
            <CompanyDomainsPanel companyId={ company?.id }
                                 customerAccountId={ customerAccountId }
                                 allowances={ allowances }
                                 loadingAllowances={ loadingAllowances }
                                 onDomainAdded={ (): void => { reloadAllowances(); } } />
        </Box>
    );
}
